var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckPrimary = function SvgCheckPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_63818)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1612_63818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 15.3337C12.0502 15.3337 15.3334 12.0504 15.3334 8.00033C15.3334 3.95024 12.0502 0.666992 8.00008 0.666992C3.94999 0.666992 0.666748 3.95024 0.666748 8.00033C0.666748 12.0504 3.94999 15.3337 8.00008 15.3337Z",
    fill: "#C7D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7438 5.64678C11.9375 5.91098 11.8942 6.26675 11.7153 6.54125C10.2711 8.75725 9.18657 10.1993 8.50968 11.0415C8.06631 11.5931 7.27678 11.6342 6.77278 11.1374C6.15124 10.5247 5.28258 9.61438 4.38324 8.49981C4.14541 8.20508 4.09624 7.79138 4.32874 7.49241C4.51074 7.25841 4.71594 7.05545 4.90494 6.89098C5.25451 6.58685 5.76668 6.65488 6.08221 6.99418C6.99161 7.97208 7.53858 8.65218 7.53858 8.65218C7.53858 8.65218 8.44821 7.30561 9.90921 5.23125C10.1485 4.89151 10.5794 4.73291 10.9391 4.94098C11.2041 5.09428 11.5054 5.32161 11.7438 5.64678Z",
    fill: "#312E81"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_63818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1612_63818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })))));
};
export default SvgCheckPrimary;